export default {
  CONNECTIVITY_UPDATE_STATUS: 'Connectivity/UPDATE_STATUS',
  CONNECTIVITY_LOADING: 'Connectivity/UPDATE_LOADING',
  CONNECTIVITY_ERROR: 'Connectivity/CONNECTIVITY_ERROR'
} as const
